module.exports = __webpack_public_path__ + "img/solo.070574f6.svg";